import { gql } from "gql";

export const GET_PERSON_NOTIFICATIONS = gql(`
  query GetPersonNotifications($pagination:PageRequest, $filter:NotificationFilter) {
    getPersonNotifications(pagination:$pagination, filter:$filter) {
      content {
        ...NotificationListItem
      }
      total
    }
  }
`);
